import HTTP from '../HTTP';

const RESEAUX_URL = 'ReseauxNumeriques/';

export async function browseReseauxNumerique(dateDeVisualisation, avecConfreres) {
  try {
    const response = await HTTP.get(RESEAUX_URL + '?datevisualisation=' + dateDeVisualisation + '&avecConfreres=' + avecConfreres);
    return response;
  } catch (e) {
    throw e;
  }
}

export async function sendColor(num, couleur) {
  try {
    const response = await HTTP.post(RESEAUX_URL + num + '/couleur', { couleur });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getFicheReseauxNumerique(data) {
  const response = await HTTP.post(RESEAUX_URL + 'ficheReseauxNumerique', data, { responseType: 'blob' });
  return response;
}

export async function getCompletReseauNumeriqueAsync(id) {
  try {
    const response = await HTTP.get(RESEAUX_URL + 'GetCompletReseauNumeriqueAsync/' + id);
    return response;
  } catch (e) {
    throw e;
  }
}



// WEBPACK FOOTER //
// ./src/api/reseauxNumerique/index.js